import React, {Component} from 'react';
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import {AddShippingCostStates} from "./types/AddShippingCostTypes";
import {shippingCostService} from "../../services/otodisApi/ShippingCostService";
import withAuth from "../../hoc/withAuth";
import {Button, Col, Modal} from "antd";
import {LeftOutlined, SaveOutlined} from "@ant-design/icons";
import {HotTable} from '@handsontable/react';
import './AddShippingCost.css';

export interface AddShippingCostProps {
}

class AddShippingCost extends Component<AddShippingCostProps & any, AddShippingCostStates> {
    private readonly initState!: AddShippingCostStates;
    private readonly id: string;
    private readonly hotSettings: any;
    private readonly hotTableComponent: React.RefObject<any>;

    constructor(props: AddShippingCostProps & any | any) {
        super(props);

        this.initState = {
            processing: false,
            processingFetchTableData: true,
            dealerCode: props.match.params.dealerCode.replace(/-/g, '#'),
            dataConfig: [],
            pageSize: 500,
            modalAddWarehouse: false,
            addProcessing: false,
        }
        this.state = {...this.initState}

        this.id = 'hot';
        this.hotSettings = {
            data: [['', '', '', '', '', '', '', ''], ['', '', '', '', '', '', '', '']],
            colHeaders: ['Kode Kota', 'PELWIL', 'PDI', 'BPKON', 'BPDEAD', 'BPDEAB', 'BIAYA BIRO JASA', 'TOL'],
            width: '100%',
            colWidths: 120
        };
        this.hotTableComponent = React.createRef();
    }

    onDealerChange = async (data: any) => {
        await this.promisedSetState({
            processingFetchTableData: true,
            dealerCode: data.value,
        });
    }

    async componentDidMount() {

    }

    onSubmit = async () => {
        const dataTable = this.hotTableComponent.current.hotInstance.getData();
        const product: any = [];

        for (const item of dataTable) {
            if (item[0]) {
                product.push({
                    city_code: item[0],
                    pelwil: (item[1]) ? parseInt(item[1]?.replace(/,/g, '').replace(/,/g, '/')) : 0,
                    pdi: (item[2]) ? parseInt(item[2]?.replace(/,/g, '').replace(/,/g, '/')) : 0,
                    bpkon: (item[3]) ? parseInt(item[3]?.replace(/,/g, '').replace(/,/g, '/')) : 0,
                    bpdead: (item[4]) ? parseInt(item[4]?.replace(/,/g, '').replace(/,/g, '/')) : 0,
                    bpdeab: (item[5]) ? parseInt(item[5]?.replace(/,/g, '').replace(/,/g, '/')) : 0,
                    bureau_fee: (item[6]) ? parseInt(item[6]?.replace(/,/g, '').replace(/,/g, '/')) : 0,
                    tol: (item[7]) ? parseInt(item[7]?.replace(/,/g, '').replace(/,/g, '/')) : 0,
                });
            }
        }

        const input = {
            dealer_code: this.state.dealerCode,
            admin_id: "admin",
            data: product
        }

        try {
            await shippingCostService.createUpdateData(
                input
            ).then(() => {
                Modal.success({
                    title: 'Proses Sukses',
                    content: 'Data berhasil diupdate'
                });
                setTimeout(function () {
                    window.location.reload();
                }, 2000);
            });
        } catch (e) {
            Modal.error({
                title: 'Proses Gagal',
                content: 'Server Menolak Inputan Anda :' + e
            });
            await this.promisedSetState({
                processing: false,
            });
        }

        if (product?.length === 0) {
            Modal.error({
                title: 'Proses Gagal',
                content: 'Data tidak lengkap'
            });
            await this.promisedSetState({
                processing: false,
            });
            return;
        }

        await this.promisedSetState({
            processing: true,
        });
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <MainLayout noPadNoMar={true} onChangeDealer={this.onDealerChange} breadcrumbPath={`Setting`} breadcrumbMenu={`Add / Update Biaya Tujuan`} defaultSelectedKeys={['m-setting-shipping']} defaultOpenKeys={['sm-setting']}>
                    <Col style={{float: "right"}} span={24} className={`pad-10`}>
                        <a href={`/${this.state.dealerCode.replace(/#/g, '-')}/shipping-cost`}>
                            <Button icon={<LeftOutlined/>}>Cancel</Button>
                        </a>
                    </Col><br/><br/>

                    <Col span={24} className={`pad-10`}>

                        <Button type={'primary'}
                                icon={<SaveOutlined/>}
                                loading={this.state.processing}
                                onClick={this.onSubmit}
                        >Update Data
                        </Button> <br/><br/>

                        <div>
                            <HotTable ref={this.hotTableComponent} id={this.id} settings={this.hotSettings}/>
                        </div>
                    </Col>
                </MainLayout>
            </React.Fragment>
        );
    }
}

export default (withAuth(withRouter(AddShippingCost), 27));
